import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/price-per-square-foot-calculator',
  component: () => import('../../routes/PricePerSqFt.svelte'),
  card: {
    id: 'price-per-square-foot',
    title: 'Price Per Square Foot',
    description: 'Calculate property price per sqft to compare values across different properties.',
    icon: 'home',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/price-per-square-foot-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Price Per Square Foot Calculator – Compare Property Values',
    description: 'Free price per square foot calculator for real estate. Compare property values across different sized homes by calculating the cost per square foot.',
  },
};

export default meta;
